import { call, delay, put, race, select, take } from 'redux-saga/effects';
import * as actionTypes from '../redux/actionTypes';
import { uniqBy } from 'lodash';
import {
  dismissToast,
  getLatestNotificationsError,
  getLatestNotificationsSuccess,
  getNotificationsSuccess,
} from '../redux/actions';
import { getNotifications } from '../services/api';
import { NOTIFICATIONS_NEW } from '../constants';
import { handleOnClose, onShowToastHandler } from '../utils';
import { selectNotifications, selectSidebarIsVisible } from 'modules/Notifications/redux/selectors';
import { setUnreadCounter } from 'modules/Notifications/redux/actions';
import { selectSiteMap } from 'modules/App/utils/selectors';

const NOTIFICATIONS_POLL_INTERVAL = 1000 * 60;

export function* pollNotifications() {
  while (true) {
    const { isOk, data, error } = yield call(getNotifications, {
      type: NOTIFICATIONS_NEW,
      size: 5,
    });

    if (isOk) {
      const { notifications, unreadCount } = data;
      const sidebarIsVisible = yield select(selectSidebarIsVisible);

      yield put(setUnreadCounter(unreadCount));

      if (!sidebarIsVisible) {
        const siteMap = yield select(selectSiteMap);
        notifications && notifications.forEach(onShowToastHandler(siteMap, true));
      } else {
        const notificationsObject = yield select(selectNotifications);
        const sidebarNotifications = notificationsObject.toJS();

        notifications.forEach(({ id, notificationId, eventTypeId }) =>
          handleOnClose(id, notificationId, eventTypeId).apply(null),
        );

        yield put(
          getNotificationsSuccess(
            {
              unreadCount,
              notifications: uniqBy([...notifications, ...sidebarNotifications], 'id'),
            },
            true,
          ),
        );
      }

      yield put(getLatestNotificationsSuccess(notifications));
    } else {
      getLatestNotificationsError(error);
    }

    yield delay(NOTIFICATIONS_POLL_INTERVAL);
  }
}

export function* pollingWatcherSaga() {
  const [, stopPolling] = yield race([
    call(pollNotifications),
    take(actionTypes.STOP_NOTIFICATIONS_POLLING),
  ]);

  if (stopPolling) {
    yield put(dismissToast({ clearWaitingQueue: true }));
  }
}
